// extracted by mini-css-extract-plugin
export var leftBox = "whyAgile-module--leftBox--6a47a";
export var teamImage = "whyAgile-module--teamImage--eb34e";
export var thumbnail_image_wrap = "whyAgile-module--thumbnail_image_wrap--56f59";
export var title_div = "whyAgile-module--title_div--75ba0";
export var videoDiv = "whyAgile-module--videoDiv--5c2d6";
export var videoWrap = "whyAgile-module--videoWrap--25259";
export var video_icon = "whyAgile-module--video_icon--8722d";
export var whyAgileImageWrap = "whyAgile-module--whyAgileImageWrap--d29ee";
export var whyAgileWrap = "whyAgile-module--whyAgileWrap--82231";
export var why_agile_info = "whyAgile-module--why_agile_info--deea0";
export var why_agile_listing = "whyAgile-module--why_agile_listing--37e29";
export var why_agile_wrap = "whyAgile-module--why_agile_wrap--df497";